import {
  CardMarketConditionCodeType,
  CardMarketConditionNameType,
  CardTraderConditionValueType,
} from "magic-shared-types";
import {
  BasicCardStats,
  CardConditionCardMarketType,
  CardConditionCardTraderType,
  CardLanguageCardTraderForSelectType,
  CardLanguageCardTraderType,
} from "./type";

export const DEFAULT_MAGIC_ID = 1;

export const CARD_CONDITIONS_CARDTRADER: CardConditionCardTraderType[] = [
  { value: "Near Mint", code: "NM", color: "#87b726", hotKey: "w" },
  { value: "Slightly Played", code: "SP", color: "#c8d400", hotKey: "e" },
  { value: "Moderately Played", code: "MP", color: "#f9b000", hotKey: "r" },
  { value: "Played", code: "PL", color: "#ee7203", hotKey: "t" },
  { value: "Poor", code: "PO", color: "#b13907", hotKey: "y" },
];

export const CARD_CONDITIONS_CARDMARKET: CardConditionCardMarketType[] = [
  { value: "Near Mint", code: "NM", color: "#87b726" },
  { value: "Excellent", code: "EX", color: "#c8d400" },
  { value: "Good", code: "GD", color: "#f9b000" },
  { value: "Light Played", code: "LP", color: "#ee7203" },
  { value: "Played", code: "PL", color: "#ee7203" },
  { value: "Poor", code: "PO", color: "#b13907" },
];

export const CONDITION_MAPPING_CARDMARKET_CARDTRADER: Record<
  CardMarketConditionNameType,
  CardTraderConditionValueType
> = {
  "Near Mint": "Near Mint",
  Excellent: "Slightly Played",
  Good: "Moderately Played",
  "Light Played": "Played",
  Played: "Played",
  Poor: "Poor",
};

export const CONDITION_MAPPING_CARDMARKET_CODE_CARDTRADER: Record<
  CardMarketConditionCodeType,
  CardTraderConditionValueType
> = {
  NM: "Near Mint",
  EX: "Slightly Played",
  GD: "Moderately Played",
  LP: "Played",
  PL: "Played",
  PO: "Poor",
};

export const CONDITION_MAPPING_CARDTRADER_CARDMARKET: Record<
  CardTraderConditionValueType,
  CardMarketConditionNameType[]
> = {
  "Near Mint": ["Near Mint"],
  "Slightly Played": ["Excellent"],
  "Moderately Played": ["Good"],
  Played: ["Light Played", "Played"],
  Poor: ["Poor"],
};

export const CARD_LANGUAGES: CardLanguageCardTraderType[] = [
  {
    value: "en",
    label: "English",
    flag: "https://flagcdn.com/gb.svg",
    hotKey: "a",
  },
  {
    value: "fr",
    label: "French",
    flag: "https://flagcdn.com/fr.svg",
    hotKey: "s",
  },
  {
    value: "de",
    label: "German",
    flag: "https://flagcdn.com/de.svg",
    hotKey: "d",
  },
  {
    value: "es",
    label: "Spanish",
    flag: "https://flagcdn.com/es.svg",
    hotKey: "f",
  },
  {
    value: "it",
    label: "Italian",
    flag: "https://flagcdn.com/it.svg",
    hotKey: "g",
  },
  {
    value: "zh-CN",
    label: "Simplified Chinese",
    flag: "https://flagcdn.com/cn.svg",
    hotKey: "h",
  },
  {
    value: "jp",
    label: "Japanese",
    flag: "https://flagcdn.com/jp.svg",
    hotKey: "j",
  },
  {
    value: "pt",
    label: "Portuguese",
    flag: "https://flagcdn.com/pt.svg",
    hotKey: "k",
  },
  {
    value: "ru",
    label: "Russian",
    flag: "https://flagcdn.com/ru.svg",
    hotKey: "l",
  },
  {
    value: "kr",
    label: "Korean",
    flag: "https://flagcdn.com/kr.svg",
    hotKey: "m",
  },
  {
    value: "zh-TW",
    label: "Traditional Chinese",
    flag: "https://flagcdn.com/tw.svg",
    hotKey: "n",
  },
];

export const LANGUAGE_FOR_DROPDOWN: CardLanguageCardTraderForSelectType[] = [
  { value: "en", label: "🇬🇧 English" },
  { value: "fr", label: "🇫🇷 French" },
  { value: "de", label: "🇩🇪 German" },
  { value: "es", label: "🇪🇸 Spanish" },
  { value: "it", label: "🇮🇹 Italian" },
  { value: "zh-CN", label: "🇨🇳 Simplified Chinese" },
  { value: "jp", label: "🇯🇵 Japanese" },
  { value: "pt", label: "🇵🇹 Portuguese" },
  { value: "ru", label: "🇷🇺 Russian" },
  { value: "kr", label: "🇰🇷 Korean" },
  { value: "zh-TW", label: "🇹🇼 Traditional Chinese" },
];

export const MAPPED_NUMBERS_TO_LETTERS: Record<number | string, string> = {
  0: "a",
  1: "b",
  2: "c",
  3: "d",
  4: "e",
  5: "f",
  6: "g",
  7: "h",
  8: "i",
  9: "l",
};

export const MAPPED_LETTERS_TO_NUMBERS: Record<string, number> = {
  a: 0,
  b: 1,
  c: 2,
  d: 3,
  e: 4,
  f: 5,
  g: 6,
  h: 7,
  i: 8,
  l: 9,
};

//---------------------------- MOCK FOR PRICING------------------------------

export const userToExclude = [
  "GamestartPR",
  "OptimaCollectPro",
  "Urza s Consulting",
  "LaFeniceBergamo",
  "IlParadisoDelNerd",
  "ChimeraTrading",
  "CammelloCollectibles",
  "Cardwallet EU",
  "Laconteacag",
  "Twofortrading",
  "Gamestimespoleto",
  "Jonyn",
];

export const canSellWithCtZero = true;
export const countryToExclude = [
  "US",
  "CA",
  "GB",
  "AU",
  "BR",
  "FI",
  "SE",
  "NO",
  "CN",
  "EE",
  "TW",
];

//---------------------------------------------------------------------

export const BASE_SERVER_PATH = process.env.REACT_APP_MY_SERVER;

export const DEFAULT_STATE_CARD: BasicCardStats = {
  quantity: 1,
  price: 1000,
  condition: "Near Mint",
  language: "en",
  finish: "regular",
  signed: false,
  description: "",
  altered: false,
  isFirstEdition: false,
  isReversed: false,
};

//--------------------------- Local storage key ----------------------------
export const LOCAL_STORAGE_DEFAULT_CARD_STATS = "default-stats-data";
